export default import.meta.ROLLUP_FILE_URL_JWpBCev5Tg4_sW4q$lpPTQ